import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AgentCallCrmContextResponse } from '../models/agent-call.model';

/**
 * Wrapper de los endpoints específicos del agente sobre llamadas
 * (`/api/agent/calls/*`). En esta fase solo se expone `getCrmContext`; los demás
 * (transfer/close/notes/answer/assign) quedan para fases posteriores si se
 * decide migrar el control del agente desde el SDK al backend.
 */
@Injectable({ providedIn: 'root' })
export class AgentCallApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/agent/calls`;

  getCrmContext(callId: number): Observable<AgentCallCrmContextResponse> {
    return this.http.get<AgentCallCrmContextResponse>(`${this.base}/${callId}/crm-context`);
  }
}
